//Obras
export const SINGLE_PROYECTO_RECEIVED = "SINGLE_PROYECTO_RECEIVED";
export const SET_PROPERTY_PROYECTO = "SET_PROPERTY_PROYECTO";
export const CREATE_NUEVA_PROYECTO = "CREATE_NUEVA_PROYECTO";
export const PROYECTOS_RECEIVED = "PROYECTOS_RECEIVED";
export const DELETE_PROYECTO = "DELETE_PROYECTO";
export const EDIT_PROYECTO = "EDIT_PROYECTO";
export const VIEW_OPTIONS = "VIEW_OPTIONS";
export const HIDE_OPTIONS = "HIDE_OPTIONS";
